<template>
  <button type="button" :class="cssClass" @click="openModal">
    <slot>
    </slot>
  </button>
</template>

<script>
export default {
  props: [
    'cssClass',
    'videoType',
    'videoData'
  ],
  methods: {
    openModal: function() {
      this.$store.dispatch('videoModal/setVideoInfo', { type: this.videoType, data: this.videoData });
      this.$store.dispatch('videoModal/open');
    }
  }
}
</script>